<template>
  <ul class="sf-list" :class="marginClass">
    <slot />
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  noMargin?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  noMargin: false,
})

const marginClass = computed(() => ({ 'tw-m-0': props.noMargin }))
</script>
